import { IBienLaiViewTheoLopActionTypes } from "../../action-types/bien-lai/IBienLaiViewTheoLopActionTypes";
import {
  IBienLaiViewTheoLopReducer,
  IBienLaiViewTheoLopsReducer,
} from "../../reducer-model/bien-lai/IBienLaiViewTheoLopReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IBienLaiViewTheoLopsReducer = {
  lops: [],
};
export const bienLaiViewTheoLopReducer = (
  state: IBienLaiViewTheoLopsReducer = iniState,
  action: IBienLaiViewTheoLopActionTypes
): IBienLaiViewTheoLopsReducer => {
  switch (action.type) {
    case "BIEN_LAI_VIEW_THEO_LOP_LOAD_START":
      const { hoc_ky, nam_hoc, id_lop } = action.payload;
      const lopExisted = state.lops.find(
        (x) =>
          x.hoc_ky === hoc_ky && x.nam_hoc === nam_hoc && x.id_lop === id_lop
      );
      const lopReducer: IBienLaiViewTheoLopReducer = lopExisted ?? {
        bienLais: [],
        hoc_ky: hoc_ky,
        nam_hoc: nam_hoc,
        id_lop,
        status: eReducerStatusBase.is_loading,
      };
      return {
        ...state,
        lops: [
          lopReducer,
          ...state.lops.filter(
            (x) =>
              x.hoc_ky !== hoc_ky &&
              x.nam_hoc !== nam_hoc &&
              x.id_lop !== id_lop
          ),
        ],
      };
    case "BIEN_LAI_VIEW_THEO_LOP_LOAD_SUCCESS":
      return {
        ...state,
        lops: state.lops.map((sv) => {
          if (
            sv.hoc_ky === action.payload.request.hoc_ky &&
            sv.nam_hoc === action.payload.request.nam_hoc &&
            sv.id_lop === action.payload.request.id_lop
          ) {
            return {
              ...sv,
              status: eReducerStatusBase.is_completed,
              bienLais: action.payload.data,
            };
          }
          return sv;
        }),
      };
    case "BIEN_LAI_VIEW_THEO_LOP_LOAD_ERRR":
      return {
        ...state,
        lops: state.lops.map((sv) => {
          if (
            sv.hoc_ky === action.payload.request.hoc_ky &&
            sv.nam_hoc === action.payload.request.nam_hoc &&
            sv.id_lop === action.payload.request.id_lop
          ) {
            return {
              ...sv,
              status: eReducerStatusBase.is_completed,
              bienLais: [],
            };
          }
          return sv;
        }),
      };
    case "BIEN_LAI_VIEW_THEO_LOP_HUY_PHIEU_START":
      return {
        ...state,
        lops: state.lops.map((sv) => {
          if (
            sv.hoc_ky === action.payload.request.hoc_ky &&
            sv.nam_hoc === action.payload.request.nam_hoc &&
            sv.id_lop === action.payload.request.id_lop
          ) {
            return {
              ...sv,
              status: eReducerStatusBase.is_saving,
            };
          }
          return sv;
        }),
      };
    case "BIEN_LAI_VIEW_THEO_LOP_HUY_PHIEU_SUCCESS":
      return {
        ...state,
        lops: state.lops.map((sv) => {
          if (
            sv.hoc_ky === action.payload.request.hoc_ky &&
            sv.nam_hoc === action.payload.request.nam_hoc &&
            sv.id_lop === action.payload.request.id_lop
          ) {
            return {
              ...sv,
              status: eReducerStatusBase.is_need_reload,
            };
          }
          return sv;
        }),
      };
    case "BIEN_LAI_VIEW_THEO_LOP_HUY_PHIEU_ERR":
      return {
        ...state,
        lops: state.lops.map((sv) => {
          if (
            sv.hoc_ky === action.payload.request.hoc_ky &&
            sv.nam_hoc === action.payload.request.nam_hoc &&
            sv.id_lop === action.payload.request.id_lop
          ) {
            return {
              ...sv,
              status: eReducerStatusBase.is_completed,
            };
          }
          return sv;
        }),
      };
    default:
      return state;
  }
};
